import React, { useState } from 'react'
import { useSpring, animated, config } from 'react-spring'
import styled from 'styled-components'
import { GlobalStyles } from './global.style'
import { getActivities } from './api'
import Header from './components/Header'
import Settings from './components/Settings'
import Button from './components/Button'
import Cards from './components/Cards'

const goals = {
  3: 'GJZL6ZH7',
  5: 'M0NDTENR',
  7: '56OK1A22',
  10: 'KKSMD19P',
}

function App() {
  const [settings, setSettings] = useState({ count: 3 })
  const [loading, setLoading] = useState(false)
  const [items, setItems] = useState([])

  const anim = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { ...config.molasses, precision: 0.1 },
    delay: 1000,
  })

  const handleClick = () => {
    if (items.length) {
      setItems([])
      return
    }
    setLoading(true)
    getActivities(settings.count).then((activities) => {
      setItems(activities)
      setLoading(false)
      window.fathom.trackGoal(goals[settings.count], 0)
    })
  }

  return (
    <AppWrapper>
      <GlobalStyles></GlobalStyles>
      <Header selectedCount={settings.count}></Header>
      <FormWrapper style={anim}>
        <Settings onChange={setSettings}></Settings>
        <Button onClick={handleClick} disabled={loading}>
          {loading ? 'Laddar..' : items.length ? 'Börja om..' : 'Nu kör vi!'}
        </Button>
      </FormWrapper>
      <Cards items={items}></Cards>
    </AppWrapper>
  )
}

export default App

const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const FormWrapper = styled(animated.div)`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
`
